/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Name"
  
}) {
let appNameValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'name',
})
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 data="app.name"
 text={appNameValueData}
/>
{children}
</React.Fragment>)
}